<template>
  <div v-loading="work.loading" :style="style" style="position: relative;">
    <div class="RightDiv">
        <div v-show="work.urgent" class="urgentRight">急</div>
        <div v-show="work.isOutsideRework===1" class="OutsideRight">外</div>
    </div>
    <div class="isOverDayShow" :style="DayShowStyle">
        {{isOverdue(work) ? '超时'+isRemainingDay(work)+'天' : '剩余'+isRemainingDay(work)+'天'}}
    </div>
    <div class="statusShow" v-if="work.status === 'INTERRUPT' || work.status.startsWith('MACHINE_REPAIR')" v-loading="$isLoading('WorkStatus')">
        {{work.status | valueName('WorkStatus')}}
    </div>
    <el-dropdown :style="{'margin-top': work.urgent ? '0px' : 0}"
                 style="color: black; width: 100%" placement="center" @command="handleCommand"
                 size="big">
      <div :style="{opacity:  machineRepair ? 0.3 : 1}">
        <work-card-item :work="work" type="carNo"></work-card-item>
        <work-card-item :work="work" type="brandModel"></work-card-item>
        <work-card-item :work="work" type="color"></work-card-item>
        <work-card-item :work="work" type="consultantName"></work-card-item>
        <work-card-item :work="work" type="enterTime"></work-card-item>
        <work-card-item :work="work" type="estimateDeliveryTime"></work-card-item>
        <work-card-item :work="work" type="durationInFactory"></work-card-item>
        <work-card-item :work="work" type="sheetMetalWH"></work-card-item>
        <work-card-item :work="work" type="paintArea"></work-card-item>
        <template v-if="work.dispatchable">
          <work-card-item v-if="work.teamId" :work="work" type="teamName"></work-card-item>
          <work-card-item v-else :work="work" type="technicianName"></work-card-item>
        </template>
        <template  v-if="work.status === 'INTERRUPT' || work.status.startsWith('MACHINE_REPAIR')">
          <work-card-item :work="work" type="statusReason"></work-card-item>
        </template>
        <work-card-item v-if="work.progress !== null" :work="work" type="progress"></work-card-item>
        <!-- <work-card-item v-if="work.status === 'INTERRUPT' || work.status.startsWith('MACHINE_REPAIR')"
                        :work="work"
                        type="status">
        </work-card-item> -->
      </div>
      <template #dropdown v-if="!schshow">
        <el-dropdown-menu style="min-width: 150px;overflow-y:auto;height: 100%;padding: 0px;">
          <template v-if="menu && menu.length > 0">
            <el-dropdown-item v-for="(item, index) in menu" :key="index" :command="item.command">{{item.name}}
            </el-dropdown-item>
          </template>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>

<script>
  import WorkCardItem from '@/views/kanban/components/WorkCardItem'
  import { statisticsDataMixin } from '@/views/mixins/StatisticsData'

  export default {
    name: 'WorkCard',
    mixins: [statisticsDataMixin],
    components: { WorkCardItem },
    props: {
      work: {
        required: true,
        type: Object
      },
      menu: {
        type: Array,
        default () {
          return null
        }
      },
      schshow: {
        type: Boolean
      }
    },
    methods: {
      handleCommand (command) {
        this.$emit('command', {
          command,
          work: this.work
        })
      },
      isOverdue (work) {
        return new Date(work.estimateDeliveryTime.replace(/-/g, '/')).getTime() < new Date().getTime()
      },
      isRemainingDay (work) {
        var a = new Date(work.estimateDeliveryTime.replace(/-/g, '/')).getTime()
        var b = new Date().getTime()
        var c = Math.abs(a - b) / (1000 * 3600 * 24)
        var d
        if (a - b < 0) { d = Math.floor(c) } else { d = Math.floor(c) + 1 }
        return d
      }
    },
    computed: {
      machineRepair () {
        return this.work.status.startsWith('MACHINE_REPAIR')
      },
      style () {
        let color = '#b38a61'
        if (this.isOverdue(this.work)) {
          color = 'red'
        } else if (this.isDueToday(this.work)) {
          color = 'yellow'
        } else if (this.isDueTomorrow(this.work)) {
          color = '#9966ff'
        } else {
          color = '#1890ff'
        }
        return {
          border: '2px solid ' + color
        }
      },
      DayShowStyle () {
        var color = ''
        if (this.isOverdue(this.work)) {
            color = '#A8C0F4'
        } else {
            color = '#6797F3'
        }
        return {
            background: color
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .item {
    height: 17px;
    margin: 3px 4px;
  }

  /deep/ .el-progress-bar__innerText {
    color: black;
  }

  /deep/ .el-progress-bar__outer {
    background-color: #e2e2e2;
    border-radius: 8px;
  }

  @keyframes scale {
    0% {
      transform: scale(1)
    }
    50%, 75% {
      /*transform: scale(2)*/
      transform: scale(1)
    }
    78%, 100% {
      opacity: 0
    }
  }

  .redLight {
    width: 10px;
    height: 10px;
    background-color: red;
    border-radius: 50%;
    /*margin: 100px 100px 50px 200px;*/
  }

  .redLight:before {
    content: '';
    display: block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    opacity: .7;
    background-color: red;
    animation: scale 2s infinite cubic-bezier(0, 0, .49, 1.02);
    animation-delay: 200ms;
  }

  .RightDiv{
    width: 45px;
    height: 16px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: absolute;
    top: 3px;
    right: 10px;
  }

  .urgentRight{
    width: 16px;
    height: 16px;
    line-height: 16px;
    text-align: center;
    background-color: #A8C0F4;
    font-size: 12px;
  }
  .OutsideRight{
    width: 16px;
    height: 16px;
    line-height: 16px;
    text-align: center;
    background-color:#F4FC78;
    font-size: 12px;
    margin-left: 5px;
  }
  .isOverDayShow{
    width: 60px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 12px;
    position: absolute;
    right:10px;
    top: 135px;
    border-radius: 10px;
  }
  .statusShow{
    width: 60px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background-color: #CCCCD1;
    font-size: 12px;
    position: absolute;
    right:10px;
    top: 170px;
    border-radius: 10px;
  }
</style>
